import { cn } from "@/lib/utils";
import { cva, VariantProps } from "class-variance-authority";
import React from "react";

const buttonVariants = cva(
  "inline-flex justify-center items-center gap-2 disabled:opacity-50 rounded-md focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring [&_svg]:size-5 font-medium text-sm whitespace-nowrap transition-colors enabled:cursor-pointer [&_svg]:pointer-events-none disabled:pointer-events-none [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default: "bg-primary text-white hover:bg-secondary",
        contained: "bg-secondary text-white hover:bg-primary",
        outlined:
          "bg-transparent text-white border-2 border-white hover:bg-secondary ",
        icon: "bg-white hover:bg-primary border-2 border-secondary rounded-lg transition-all duration-300 cursor-pointer !h-10 !w-10",
        "outlined-secondary":
          "bg-white text-secondary border-2 border-secondary hover:bg-primary ",
        "outlined-primary":
          "bg-white text-primary border-2 border-primary hover:border-secondary hover:text-secondary",
        white: "bg-white text-secondary"
      },
      size: {
        default: "h-9 px-4 py-2 text-base",
        sm: "h-8 rounded-md px-3 text-xs",
        lg: "h-10 rounded-2xl xl:px-6 xl:py-8 px-4 py-6 text-sm xl:text-lg",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
);

type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> &
  VariantProps<typeof buttonVariants> & {};

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, variant, size, ...props }, ref) => (
    <button
      className={cn(buttonVariants({ variant, size, className }))}
      ref={ref}
      {...props}
    />
  )
);

Button.displayName = "Button";

export { Button };
